module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Alex Rutherford\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("ALEX RUTHERFORD is the pen name for Diana and Michael Preston, whose nonfiction has been awarded the Los Angeles Times Science and Technology Prize and been praised worldwide. They are also authors of "), _c('I', [_vm._v("Raiders from the North, A Kingdom Divided, ")]), _vm._v("and most recently "), _c('I', [_vm._v("Ruler of the World")]), _vm._v(". They live in London.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Ag4yCq/tc-custom/9781250034458.jpg?1731411132543",
      "alt": "This image is the cover for the book Tainted Throne, Empire of the Moghul"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Tainted Throne, Empire of the Moghul\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("India, 1606. Jahangir, the triumphant Moghul Emperor and ruler of most of the Indian subcontinent, is doomed. No amount of wealth and ruthlessness can protect him from his sons' desire for power. The glorious Moghul throne is worth any amount of bloodshed and betrayal; once Jahangir raised troops against his own father; now he faces a bloody battle with Khurram, the ablest of his warring sons. Worse is to come. Just as the heirs of Timur the Great share intelligence, physical strength, and utter ruthlessness, they also have a great weakness for wine and opium. Once Jahangir is tempted, his talented wife, Mehrunissa, is only too willing to take up the reins of the empire. And with Khurram and his half-brothers each still determined to be their father's heir, the savage battle for the Moghul throne will be more ferocious than even Timur could have imagined."), _c('br'), _c('br'), _c('i', [_vm._v("The Tainted Throne, ")]), _vm._v("the fourth installment in Alex Rutherford's internationally bestselling historical adventure series, is set in the Moghul Empire, featuring a culture reminiscent of the Dothraki in "), _c('i', [_vm._v("A Game of Thrones")])]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    St. Martin’s Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0